import { callAuthorizedGraphQLEndpoint } from '../../Module/graphQL'

const sendClientVerificationByEmail = input => {
  const mutation = `mutation sendClientVerificationEmail($input: SendClientVerificationEmailInput) {
    sendClientVerificationEmail(input: $input){
        success
        error,
      }
    }`
  const variables = { input }
  return callAuthorizedGraphQLEndpoint(mutation, variables)
}

const isClientEmailVerified = () => {
  const mutation = `mutation getClientEmailVerified($input: GetClientEmailVerifiedInput) {
    getClientEmailVerified(input: $input){
      success
      error,
    }
  }`
  return callAuthorizedGraphQLEndpoint(mutation)
}

export { sendClientVerificationByEmail, isClientEmailVerified }
